import { faSearchDollar } from "@fortawesome/free-solid-svg-icons";
export const entrySourceSelection = {
    name: "Entry Source Selection",
    minSize: [5, 1],
    icon: faSearchDollar,
    description: "Choose Entry Source",
    defaultConfig: {
        defaultValue: null,
        key: "Entry Source",
    },
    type: "input",
    category: "dashboard",
};
